module.exports = __webpack_public_path__ + "img/Screenshot-5.52e0e3f8.png";